import { TeamActionTypes, ApiConfig } from 'app/modules/teamsOld/models';
import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';
import { CreateTagPayload } from 'app/modules/tags/requests';
import { FullTagResponse } from 'app/modules/tags/responses';

export const retrieveAllTags = () =>
  createAction(TeamActionTypes.RETRIEVE_ALL_TAGS);

export const retrieveAllTagsSuccess = (result: FullTagResponse[]) =>
  createAction(TeamActionTypes.RETRIEVE_ALL_TAGS_SUCCESS, result);

export const addTag = (
  payload: CreateTagPayload,
  handleSuccess?: (result: FullTagResponse) => void,
) => createAction(TeamActionTypes.ADD_TAG, payload, handleSuccess);

export const addTagSuccess = (payload: FullTagResponse) =>
  createAction(TeamActionTypes.ADD_TAG_SUCCESS, payload);

export const retrieveAPIConfigs = () =>
  createAction(TeamActionTypes.RETRIEVE_API_CONFIGS);

export const retrieveAPIConfigsSuccess = (result: ApiConfig) =>
  createAction(TeamActionTypes.RETRIEVE_API_CONFIGS_SUCCESS, result);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TeamActionsList = {
  retrieveAPIConfigs,
  retrieveAPIConfigsSuccess,
  retrieveAllTags,
  retrieveAllTagsSuccess,
  addTag,
  addTagSuccess,
};

export type TeamActions = ActionsUnion<typeof TeamActionsList>;

export default TeamActions;
